import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const saved = localStorage.getItem("homiie_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export const setToken = (t) => {
    if (t) {
        localStorage.setItem("homiie_token", t);
        api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    } else {
        localStorage.removeItem("homiie_token");
        delete api.defaults.headers.common["Authorization"];
    }
};

export const getToken = () => localStorage.getItem("homiie_token");

export function apiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
    if (detail.msg) return detail.msg;
    return String(detail);
}

export default api;
